/**
 * 브랜드 마크 · 워드마크 (시안 04 README 5.17). 찻잔 마크 + 「인생상회」 마루 부리 700.
 *
 * - 가로 묶음(상단 바 · 작은 자리): 마크 = 글자 × 1.2, 간격 = 글자 × 0.22, 세로 가운데. 상단 바는 마크 26 + 22px 글자
 * - 세로 묶음(가운데 정렬 큰 자리, 글자 32 이상): 마크 = 글자 × 1.2 → 간격 글자 × 0.3 → 워드마크 → 간격 0.3 → 부제
 * - 어두운 바탕(사진 위)은 크림 마크와 크림 글자. 사진 위에 팥 마크를 쓰지 않습니다
 * - 별은 워드마크 · 단골 카드에서 빠지고(단골 카드도 찻잔, 사용자 지시 2026-10-13) 새 소식 점에만 남습니다
 */
const MARK_SRC = {
    brand: '/assets/brand/logo-mark.png',
    cream: '/assets/brand/logo-mark-cream.png',
};

export function BrandMark({ size = 26, tone = 'brand', className = '' }) {
    return (
        <img
            src={MARK_SRC[tone]}
            width={size}
            height={size}
            alt=""
            aria-hidden="true"
            draggable="false"
            className={`shrink-0 select-none ${className}`}
        />
    );
}

/** 가로 묶음. 상단 바 기본값: 글자 22 · 마크 26 · 간격 5 */
export function Wordmark({ textSize = 22, lineHeight = 28, tone = 'brand', as: Tag = 'span' }) {
    const color = tone === 'cream' ? 'text-bg' : 'text-brand';
    return (
        <Tag className="m-0 flex items-center" style={{ gap: Math.round(textSize * 0.22) }}>
            <BrandMark size={Math.round(textSize * 1.2)} tone={tone} />
            <span
                className={`font-serif font-bold ${color}`}
                style={{ fontSize: textSize, lineHeight: `${lineHeight}px`, letterSpacing: 0 }}
            >
                인생상회
            </span>
        </Tag>
    );
}

/**
 * 세로 묶음(L0 · L1 · 가입). 마크 → 워드마크 → 부제
 * @param {number} [markSize]  시안이 마크 크기를 따로 정한 화면(L0 크림 마크 52)
 */
export function WordmarkStack({ textSize = 40, lineHeight = 48, markSize = null, subtitle = null, tone = 'brand' }) {
    const gap = Math.round(textSize * 0.3);
    const color = tone === 'cream' ? 'text-bg' : 'text-brand';
    const subtitleColor = tone === 'cream' ? 'text-[#E9E1D4]' : 'text-text-secondary';
    return (
        <div className="flex flex-col items-center text-center">
            <BrandMark size={markSize ?? Math.round(textSize * 1.2)} tone={tone} />
            <h1
                className={`m-0 font-serif font-bold ${color}`}
                style={{ marginTop: gap, fontSize: textSize, lineHeight: `${lineHeight}px`, letterSpacing: 0 }}
            >
                인생상회
            </h1>
            {subtitle ? (
                <p className={`m-0 text-[15px] leading-6 ${subtitleColor}`} style={{ marginTop: gap }}>
                    {subtitle}
                </p>
            ) : null}
        </div>
    );
}

/** 안 읽은 표시 점 (시안 04: 숫자 배지 대신 점 8px brand + 1.5px bg 테두리) */
export function UnreadDot({ className = '' }) {
    return (
        <span
            aria-hidden="true"
            className={`block size-2 rounded-full border-[1.5px] border-bg bg-brand ${className}`}
        />
    );
}
